import { InlineError, Spinner } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'
import UploadImage from 'components/commons/upload-image'

export const FormBanner = ({
    show,
    onHideForm,
    dataBanner,
    isLoading,
    isLoadingBanner,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[850px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={'Setting Banner'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            {isLoadingBanner ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <div className={'flex space-x-16 px-8 py-2 mb-2'}>
                    <div
                        className={`flex-1 flex-col ${(dataBanner?.desktop_image_url?.base64 || dataBanner?.desktop_image_url?.length) && 'space-y-3'}`}
                    >
                        <div className={'font-semibold text-blue-90 required'}>Banner Desktop</div>
                        <UploadImage
                            className={'w-fit'}
                            classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                            id={`banner-desktop`}
                            value={dataBanner?.desktop_image_url?.base64 || dataBanner?.desktop_image_url}
                            onChange={(value) => onChangeForm({ name: 'desktop_image_url', value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.desktop_image_url} />
                    </div>
                    <div
                        className={`flex-1 flex-col ${(dataBanner?.mobile_image_url?.base64 || dataBanner?.mobile_image_url?.length) && 'space-y-3'}`}
                    >
                        <div className={'font-semibold text-blue-90 required'}>Banner Mobile</div>
                        <UploadImage
                            className={'w-fit'}
                            classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                            id={`banner-mobile`}
                            value={dataBanner?.mobile_image_url?.base64 || dataBanner?.mobile_image_url}
                            onChange={(value) => onChangeForm({ name: 'mobile_image_url', value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.mobile_image_url} />
                    </div>
                </div>
            )}
        </ModalForm>
    )
}
